import { useQuery } from "@tanstack/react-query";
import { httpRequest } from "@/lib";
import { FinanceEntryReportResponse } from "@/types";

type Props = {
  status: string;
  page: string | null;
  per_page?: number | null;
  employeeId: string;
  patientId: string;
  paymentMethod: string;
  startDate: string;
  endDate: string;
  accountId: string;
};

async function fetchFinancePatientReport({
  status,
  page,
  per_page,
  employeeId,
  patientId,
  paymentMethod,
  endDate,
  startDate,
  accountId
}: Props): Promise<FinanceEntryReportResponse> {
  const pageParams = !per_page
    ? `page=${page || 1}`
    : `page=${page || 1}&per_page=${per_page}`;
  const response = await httpRequest.get<FinanceEntryReportResponse>(
    `/financy-entry-report/patients?status=${status}&accountId=${accountId}&startDate=${startDate}&endDate=${endDate}&${pageParams}&employeeId=${employeeId}&patientId=${patientId}&paymentMethod=${paymentMethod}`
  );
  return response.data;
}

export function useFetchFinancePatientReportQuery({
  status,
  page,
  per_page,
  employeeId,
  patientId,
  paymentMethod,
  endDate,
  startDate,
  accountId
}: Props) {
  const financesQuery = useQuery({
    queryKey: [
      "reports",
      status,
      page,
      per_page,
      employeeId,
      patientId,
      paymentMethod,
      endDate,
      startDate,
      accountId,
    ],
    queryFn: () =>
      fetchFinancePatientReport({
        status,
        page,
        per_page,
        employeeId,
        patientId,
        paymentMethod,
        endDate,
        startDate,
        accountId,
      }),
    keepPreviousData: false,
    enabled: !!patientId,
  });

  return {
    ...financesQuery,
    data: financesQuery.data,
  };
}
